<template>
  <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 14L8 9V19L16 14Z" fill="#007893"/>
  </svg>
</template>
